import { render, staticRenderFns } from "./ApiDocs.vue?vue&type=template&id=a2074352&scoped=true"
import script from "./ApiDocs.vue?vue&type=script&lang=js"
export * from "./ApiDocs.vue?vue&type=script&lang=js"
import style0 from "./ApiDocs.vue?vue&type=style&index=0&id=a2074352&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2074352",
  null
  
)

export default component.exports